export interface ClaimsInterface {
    givenName?: string;
    surname?: string;
    emailAddress?: string;
}


export class Claims implements ClaimsInterface {
    public givenName?: string;
    public surname?: string;
    public emailAddress?: string;

    constructor(
        givenName?: string,
        surname?: string,
        emailAddress?: string
    ) {
        this.givenName = givenName;
        this.surname = surname;
        this.emailAddress = emailAddress;
    }

    static fromJson(json: any): Claims {
        return new Claims(
            json.givenName,
            json.surname,
            json.emailAddress
        );
    }
}
